<ul
    [attr.role]="isRoot ? 'navigation' : 'none'"
    [attr.aria-label]="isRoot ? 'Primary' : undefined"
    [ngClass]="ulClasses"
>
    @for (route of loopNavRoutes; track route) {
        @if (navService.shouldShowRouteLink(route, navRoutes, 0)) {
            <li
                #linkLi
                [class.small-screen-only]="route.isInUserNav"
                [routerLinkActive]="['link-active']"
                [class.link-active]="route.id === currForceSelect"
                [routerLinkActiveOptions]="{ exact: route.exact }"
            >
                <a
                    class="d-block"
                    [queryParams]="route.queryParams"
                    [routerLink]="[route.path]"
                    (click)="clickLink(route)"
                    [target]="route.openNewTab ? '_blank' : ''"
                    >{{ route.name }}</a
                >
            </li>
        }
        @if (route && route.children && !route.hasSideNav) {
            <li
                [class.small-screen-only]="route.isInUserNav"
                class="dropdown"
                [ngClass]="{
                    'bottom-arrow':
                        isRoot &&
                        !isSecondary &&
                        (currSelectedNavMenuItem.startsWith(route.id) || currOpenSecondaryNavMenu.startsWith(route.id)),
                    'dropdown-submenu': !isRoot,
                }"
                (pointerleave)="closeDropdown(route.id)"
            >
                <a
                    [id]="getHtmlId(route.id) + '_collapser'"
                    role="button"
                    [attr.aria-expanded]="currNavMenuItem !== '' && currNavMenuItem.startsWith(route.id)"
                    [attr.aria-controls]="getHtmlId(route.id)"
                    class="d-block ddlMenu"
                    style="white-space: nowrap"
                    [attr.href]="!isMobile ? route.href : null"
                    (pointerenter)="openDropdown(route.id)"
                    (pointerdown)="clickDropdown(route.id, route.href)"
                    [target]="route.openNewTab ? '_blank' : ''"
                    [ngClass]="{
                        'underline-top-nav-style':
                            isRoot &&
                            !isSecondary &&
                            (currSelectedNavMenuItem.startsWith(route.id) ||
                                currOpenSecondaryNavMenu.startsWith(route.id)),
                        'dropdown-submenu': !isRoot,
                    }"
                >
                    {{ route.name }}
                    <span
                        class="dropdown-toggle"
                        [class.isOpen]="!isRoot && currNavMenuItem !== '' && currNavMenuItem.startsWith(route.id)"
                    ></span>
                </a>

                <pcg-top-click-nav
                    [id]="getHtmlId(route.id)"
                    [attr.aria-labelledby]="getHtmlId(route.id) + '_collapser'"
                    [isRoot]="false"
                    [menuItemId]="route.id"
                    [navRoutes]="route.children"
                ></pcg-top-click-nav>
            </li>
        }
    }
</ul>
